import baseMixin from './baseMixin'
import {
    styler,
    tween,
    action,
    composite,
    stagger,
    spring,
    chain,
    delay,
    keyframes
} from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'hands-on-graphic'
    },

    methods: {
        setStyler() {
            const toEls = Array.from(
                this.baseElement.querySelectorAll('#ho-to path')
            )
            const toXYs = toEls.map(el => {
                const { x, y } = el.getBBox()
                el.style.opacity = 0
                return { x, y }
            })
            const fromEls = Array.from(
                this.baseElement.querySelectorAll('#ho-from path')
            )
            const fromXYs = fromEls.map(el => {
                const { x, y } = el.getBBox()
                return { x, y }
            })
            const tweens = fromXYs.map((from, i) => {
                const to = toXYs[i]
                return {
                    from: { x: 0, y: 0, fill: '#ffffff' },
                    to: {
                        x: to.x - from.x,
                        y: to.y - from.y,
                        fill: '#F14F1D'
                    },
                    damping: 7
                }
            })

            this.box = styler(this.baseElement.querySelector('#ho-room'))
            this.dots = fromEls.map(el => styler(el))
            this.tweens = tweens
        },

        initAction() {
            return composite({
                opacity: keyframes({
                    values: [1, 0, 0, 1],
                    times: [0, 0.33, 0.66, 1],
                    duration: 600
                }),
                box: chain(
                    delay(200),
                    tween({ from: { scale: 2 }, to: { scale: 1 } })
                ),
                position: chain(delay(300), this.skipToStart())
            })
        },

        skipToStart() {
            return action(({ update, complete }) => {
                update({ x: 0, y: 0, fill: '#ffffff' })
                complete()
            })
        },

        animationAction() {
            return composite({
                box: chain(
                    delay(300),
                    tween({
                        to: { scale: 2 },
                        from: { scale: 1 }
                        // duration: 1500
                    })
                ),
                dots: stagger(this.tweens.map(t => spring(t)), 100)
            })
        },

        animationReaction(values) {
            if (!values) return

            values.box && this.box.set(values.box)

            values.dots &&
                values.dots.forEach((v, i) => {
                    this.dots[i].set(v)
                })
        },

        initReaction(values) {
            if (!values) return

            const { box, position, opacity } = values

            opacity && this.dots.map(dot => dot.set({ opacity }))

            box && this.box.set(box)

            position && this.dots.map(dot => dot.set(position))
        }
    }
}
